/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, ComposedChart, Cell } from 'recharts';
import L from "../Lang";

export default class CM2PerMonthChart extends BaseCom {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      trend: []
    };
  }

  componentDidMount() {
    qreq.get('/api/chart/cm2-per-month', j => {
      if (j.list) {
        this.setState({ data: j.list, trend: [] });
        /*
        if(j.list.length > 4) {
          var trend = [];
          trend.push({...j.list[0], av: j.list[0].dv });
          var last = 0;
          j.list.forEach(i => {
            last += i.dv;
          });
          trend.push({...j.list[j.list.length-1], av: (last/j.list.length)});
          this.setState({ trend: trend });
        }
        */
      }
    });
  }

  render() {
    const legend = [{ value: <><L>cm</L><sup><L>2</L></sup></>, type: 'bar', id: 'ID01', color: '#7cae35' }
      /*,{ value: <><L>Projection</L></>, type: 'bar', id: 'ID01', color: '#03fc07' } */];
    return <ResponsiveContainer width="100%" height={300}>
      <BarChart
        width={500}
        height={300}
        data={this.state.data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip content={a => a ? <div className="bg-light text-dark border border-dark p-3">
          <div>{a.payload && a.payload.length > 0 && a.payload[0].payload ? a.payload[0].payload.name : null}</div>
          <div>{a.payload && a.payload.length > 0 ? a.payload[0].value : null} cm<sup><L>2</L></sup></div>
        </div> : null} />
        <Legend payload={legend} />
        <Bar type="monotone" dataKey="dv" fill="#7cae35" activeDot={{ r: 8 }}>
          {this.state.data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.name === 'Projection' ? '#03fc07' : '#7cae35'} />)}
        </Bar>
      </BarChart >
    </ResponsiveContainer>;
  }
}